module.exports = __webpack_public_path__ + "media/images/index/mobile-fc14fbab876800e98062eca63241f659.png";